import { forwardRef, type SelectHTMLAttributes } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const select = tv({
  base: [
    'h-10 w-full rounded-md border bg-[var(--color-an-surface)] px-3 text-sm',
    'border-[var(--color-an-border)] text-[var(--color-an-text)]',
    'focus-visible:outline-none focus-visible:border-[var(--color-an-primary)]',
    'disabled:cursor-not-allowed disabled:opacity-60',
  ].join(' '),
  variants: {
    invalid: {
      true: 'border-[var(--color-an-danger)]',
      false: '',
    },
  },
  defaultVariants: { invalid: false },
});

type SelectVariants = VariantProps<typeof select>;

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & SelectVariants;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, invalid, ...rest }, ref) => (
    <select ref={ref} className={select({ invalid, className })} {...rest} />
  ),
);
Select.displayName = 'Select';
